import { render } from "./Relatorios.vue?vue&type=template&id=84f4126a&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"

import "./Relatorios.vue?vue&type=style&index=0&id=84f4126a&scoped=true&lang=css"
import "./Relatorios.vue?vue&type=style&index=1&id=84f4126a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f4126a"]])

export default __exports__